<script>
    /* Единый набор значков планшета: одна сетка 24×24, одна толщина линии,
       один стиль скруглений. Раньше каждое приложение приносило свою картинку
       с CDN — они были из разных наборов и разного размера, из-за этого экран
       и выглядел собранным из кусков. */
    export let name = 'app';
    export let size = '2.5vh';

    const paths = {
        // дом
        home: ['M3.6 10.4 12 3.6l8.4 6.8V20a1 1 0 0 1-1 1h-4.6v-6.2H9.2V21H4.6a1 1 0 0 1-1-1z'],
        // витрина магазина — «мой бизнес»
        biz: ['M4 9.2h16', 'M5.4 9.2 6.6 4h10.8l1.2 5.2', 'M5.4 9.2V20h13.2V9.2', 'M9.4 20v-6h5.2v6'],
        // щит — фракция
        shield: ['M12 3.4 19.6 6.2v4.9c0 4.7-3.1 8-7.6 9.5-4.5-1.5-7.6-4.8-7.6-9.5V6.2z', 'M9.4 12.1l1.9 1.9 3.5-3.6'],
        // здание — организация
        org: ['M4 21h16', 'M6.4 21V6.6L12 4l5.6 2.6V21', 'M9.8 10.4h1.2', 'M13.4 10.4h1.2', 'M9.8 14.2h1.2', 'M13.4 14.2h1.2', 'M10.6 21v-3.4h2.8V21'],
        // здание с плюсом — создать организацию
        orgcreate: ['M4.4 21h11.2', 'M6.6 21V7.4L12 5l3.4 1.5', 'M9.6 11h1.2', 'M9.6 14.6h1.2', 'M18 13.4v6.4', 'M14.8 16.6h6.4'],
        // фура — дальнобойщик
        trucker: ['M3.2 6.4h10.4v9.8H3.2z', 'M13.6 10.2h3.9l3.3 3.3v2.7h-7.2', 'M7.4 19.4a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4', 'M17.4 19.4a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4'],
        // ящик снабжения — заказы гос.
        gos: ['M3.6 7.8h16.8v3.2H3.6z', 'M5.4 11v8.2a1 1 0 0 0 1 1h11.2a1 1 0 0 0 1-1V11', 'M9.8 14.8h4.4'],
        // внедорожник — война за хаммеры
        war: ['M3.6 14.8h16.8v-3.4l-2.4-4.2H8.2L4.8 11.4z', 'M3.6 14.8v2.6h1.9', 'M18.5 17.4h1.9v-2.6', 'M8.4 18.6a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6', 'M16 18.6a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6', 'M12.2 7.2v4.2'],
        // сумка — маркетплейс
        market: ['M5.6 8.4h12.8l-1 11.8a1 1 0 0 1-1 .9H7.6a1 1 0 0 1-1-.9z', 'M9.2 8.4V6.6a2.8 2.8 0 0 1 5.6 0v1.8'],
        // поворот экрана
        turn: ['M4.2 12.6a7.8 7.8 0 0 1 13.2-5.6', 'M17.6 3.4v3.8h-3.8', 'M19.8 11.4a7.8 7.8 0 0 1-13.2 5.6', 'M6.4 20.6v-3.8h3.8'],
        // выключение — кнопка «закрыть» в доке
        power: ['M12 3.8v7.4', 'M17.6 6.8a7.4 7.4 0 1 1-11.2 0'],
        // связь / wi-fi / заряд — для строки состояния
        wifi: ['M2.6 8.8a13 13 0 0 1 18.8 0', 'M6 12.4a8 8 0 0 1 12 0', 'M9.4 16a3.6 3.6 0 0 1 5.2 0', 'M12 19.4h.01'],
        app: ['M4.5 4.5h6v6h-6zM13.5 4.5h6v6h-6zM4.5 13.5h6v6h-6zM13.5 13.5h6v6h-6z'],
    };
</script>

<svg class="pm-ico" style="width:{size};height:{size}" viewBox="0 0 24 24" fill="none"
     stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    {#each (paths[name] || paths.app) as d}
        <path {d}/>
    {/each}
</svg>
